export const BACKEND_SERVER='https://payments.dgapi.me';
//export const BACKEND_SERVER='https://payments.dimensiongamers.net';
